import { AppState } from "../@types";

export const storageKey = "cms-mct-store";
const existingStore = window.sessionStorage.getItem(storageKey);
export const cachedStore: AppState | null = existingStore
  ? JSON.parse(existingStore)
  : null;
